import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Typography } from 'seagull';
import { timeModel } from '~/models';
import { LineItemPendingApprovalReason } from '~/types/api.model';
import { utils } from '~/utils';
import styles from './ScheduledInvoice.module.scss';
export const scheduledInvoiceColumnsTextsPath = 'pages.agreementMinisite.scheduledInvoice.columns';
export function getColumnDefs(texts) {
    return [
        {
            width: 330,
            value: texts.serviceName()
        },
        {
            width: [
                53,
                90
            ],
            hAlign: 'end',
            value: texts.quantity()
        },
        {
            width: [
                90,
                120
            ],
            hAlign: 'end',
            value: texts.rate()
        },
        {
            width: [
                70,
                90
            ],
            hAlign: 'end',
            value: texts.discount()
        },
        {
            width: [
                80,
                104
            ],
            hAlign: 'end',
            value: texts.total()
        },
        {
            width: 130,
            value: texts.status()
        },
        {
            width: 96,
            value: ''
        }
    ];
}
export const HeaderDateIndicator = (param)=>{
    let { label, date, testId } = param;
    return /*#__PURE__*/ _jsxs("div", {
        className: styles.headerDateIndicator,
        children: [
            /*#__PURE__*/ _jsx(Typography, {
                variant: "paragraph2",
                weight: "normal",
                children: label
            }),
            /*#__PURE__*/ _jsx(Typography, {
                variant: "paragraph2",
                testId: testId,
                children: timeModel.formatDateLong(date)
            })
        ]
    });
};
export const makeTestId = (chargeId)=>"scheduled-invoice-row-".concat(chargeId);
export function displayLineItemRate(rate) {
    return !rate || rate.amount.isZero() ? '' : rate.unit ? "".concat(utils.formatDollarAmount(rate.amount), "/").concat(rate.unit) : utils.formatDollarAmount(rate.amount);
}
export function getClientStatusTooltip(pendingApprovalReason) {
    switch(pendingApprovalReason){
        case LineItemPendingApprovalReason.AdHocCharge:
            return 'Your ongoing agreement does not cover this charge';
        case LineItemPendingApprovalReason.ServiceAmendment:
            return 'There is an unapproved amendment to this service';
        case LineItemPendingApprovalReason.VariableExceedsCap:
            return 'The amount charged exceeds the preapproved quantity';
        case LineItemPendingApprovalReason.VariableZeroCap:
            return 'A preapproved quantity was not set for this service';
        case LineItemPendingApprovalReason.RangeExceedsMaxPrice:
            return 'The amount charged exceeds the preapproved rate';
        case LineItemPendingApprovalReason.VariableCumulative:
            return 'The amount charged exceeds the preapproved quantity';
        case LineItemPendingApprovalReason.NonVariableCumulative:
        case LineItemPendingApprovalReason.OverlappingPeriod:
            return 'A charge for this service was issued more than once during this period';
    }
}
export function getVendorStatusTooltip(pendingApprovalReason) {
    switch(pendingApprovalReason){
        case LineItemPendingApprovalReason.AdHocCharge:
            return 'Out-of-agreement charges require client approval';
        case LineItemPendingApprovalReason.ServiceAmendment:
            return 'Amendment is pending client approval';
        case LineItemPendingApprovalReason.VariableExceedsCap:
            return 'Exceeding the preapproved quantity requires client approval';
        case LineItemPendingApprovalReason.VariableZeroCap:
            return 'A preapproved quantity was not set for this service';
        case LineItemPendingApprovalReason.RangeExceedsMaxPrice:
            return 'Exceeding the preapproved rate requires client approval';
        case LineItemPendingApprovalReason.VariableCumulative:
            return 'Exceeding the preapproved quantity requires client approval';
        case LineItemPendingApprovalReason.NonVariableCumulative:
        case LineItemPendingApprovalReason.OverlappingPeriod:
            return 'Billing this service more than once per period requires client approval';
    }
}
